import type { StageOutcomeCount } from '../../types';

const LABELS: Record<string, string> = {
  empty_session: 'Empty session',
  already_summarized: 'Already summarized',
  summary_failed: 'Summary failed',
  batch_skipped: 'Batch skipped',
  not_claimed: 'Not claimed',
  pending_escalation: 'Waiting for escalation',
  parked_for_escalation: 'Parked for escalation',
  escalation_bypassed: 'Escalation turned off',
  escalation_failed: 'Escalation failed',
  jev_failed: 'Jev failed',
  classified_by_york_llm: 'Classified by York LLM',
  no_eligible_skills: 'No eligible skills',
  skills_labeled: 'Skills labeled',
  relevance_incomplete: 'Relevance incomplete',
  type_score_written: 'Type score written',
  base_failed: 'Base score failed',
  missing_classification: 'Missing classification',
  base_batch_skipped: 'Base batch skipped',
  base_job_failed: 'Base job failed',
  insufficient_padding: 'Insufficient padding',
  missing_base_score: 'Missing base score',
  missing_task_or_context: 'Missing task or context',
  finalize_failed: 'Finalize failed',
};

export function outcomeLabel(code: string): string {
  return LABELS[code] || code;
}

export function visibleOutcomes(
  outcomes: StageOutcomeCount[] | undefined,
): StageOutcomeCount[] {
  return (outcomes || []).filter((row) => row.code !== 'not_recorded' && row.count);
}
